import styled from 'styled-components';

export const StyledVoidView = styled.div`
  width: 100%;
  text-align: center;
`;
